import { auditReports } from '@mi-front/api-clients';
import { ViewLoader } from '@ui/utils';
import { useClient } from '../../../../../../../core/auth/profile/hooks/useClient';
import { ReportView } from '../../../../../../../core/reports/components/ReportView';
import { useStationsWithAudit } from '../../../../../hooks/useStationsWithAudit';
import { GipReportFormActions } from '../config/form/components/ReportActions';
import { GipReportForm } from '../config/form/form';
import { useGipQueryParamsTransform } from '../config/form/hooks/useGipQueryParamsTransform';
import { useGipReportDefaultValues } from '../config/form/hooks/useGipReportDefaultValues';
import { GipReportType } from '../config/form/types';
import { mapValuesToGipReportDataDto } from '../config/utils/gip-report-values-to-data-dto';
import { GipReportResultV2 } from './components/result/GipReportResultV2';
import { useGipValuesFromReportId } from './hooks/useGipValuesFromState';

type Props = Record<string, never>;

export function GipReportPreviewView(p: Props) {
  const stations = useStationsWithAudit();
  const client = useClient();

  const defaultValues = useGipReportDefaultValues();
  const { values: passedValues, isLoading, error } = useGipValuesFromReportId();

  const paramsTransform = useGipQueryParamsTransform();

  if (isLoading) {
    return <ViewLoader />;
  }

  return (
    <ReportView<GipReportType | GipReportType>
      download={{
        local: false,
        filename: 'gip-report',
      }}
      runOnLoad={!!passedValues}
      defaultValues={passedValues ?? defaultValues}
      queryParamsTransform={paramsTransform}
      reportFn={async (values, format) => {
        const config = mapValuesToGipReportDataDto(client.id, values, stations);

        // Always use the modern API - supports both preview and download with format parameter
        return auditReports.executeGipReport(
          config,
          format ? { format } : undefined,
          format ? { responseType: 'arraybuffer' as const } : undefined,
        ) as any;
      }}
      Form={GipReportForm}
      FormActions={GipReportFormActions}
      Result={GipReportResultV2}
    />
  );
}
